// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\upload-profile-picture.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\upload-profile-picture.tsx");
  import.meta.hot.lastModified = "1760464886205.697";
}
// REMIX HMR END

import UploadProfilePicture from '~/components/auth/UploadProfilePicture';
export default function UploadProfilePictureRoute() {
  return <UploadProfilePicture />;
}
_c = UploadProfilePictureRoute;
var _c;
$RefreshReg$(_c, "UploadProfilePictureRoute");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;